"use strict";

require("core-js/modules/es6.array.filter.js");
var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));
var _model = _interopRequireDefault(require("./model"));
function cov_1qifkte0gu() {
  var path = "/codebuild/output/src609432752/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/catalog/lib/reducer.js";
  var hash = "f744f43add4d74eb9cb30c20a1b2eae744c4548a";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src609432752/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/catalog/lib/reducer.js",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 35
        },
        end: {
          line: 7,
          column: 1
        }
      },
      "1": {
        start: {
          line: 9,
          column: 16
        },
        end: {
          line: 50,
          column: 1
        }
      },
      "2": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 49,
          column: 3
        }
      },
      "3": {
        start: {
          line: 13,
          column: 6
        },
        end: {
          line: 16,
          column: 8
        }
      },
      "4": {
        start: {
          line: 18,
          column: 6
        },
        end: {
          line: 18,
          column: 64
        }
      },
      "5": {
        start: {
          line: 19,
          column: 6
        },
        end: {
          line: 23,
          column: 8
        }
      },
      "6": {
        start: {
          line: 25,
          column: 6
        },
        end: {
          line: 25,
          column: 72
        }
      },
      "7": {
        start: {
          line: 26,
          column: 6
        },
        end: {
          line: 30,
          column: 8
        }
      },
      "8": {
        start: {
          line: 32,
          column: 6
        },
        end: {
          line: 36,
          column: 8
        }
      },
      "9": {
        start: {
          line: 37,
          column: 6
        },
        end: {
          line: 41,
          column: 8
        }
      },
      "10": {
        start: {
          line: 43,
          column: 6
        },
        end: {
          line: 46,
          column: 8
        }
      },
      "11": {
        start: {
          line: 48,
          column: 6
        },
        end: {
          line: 48,
          column: 19
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 9,
            column: 16
          },
          end: {
            line: 9,
            column: 17
          }
        },
        loc: {
          start: {
            line: 9,
            column: 92
          },
          end: {
            line: 50,
            column: 1
          }
        },
        line: 9
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 9,
            column: 17
          },
          end: {
            line: 9,
            column: 79
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 9,
            column: 25
          },
          end: {
            line: 9,
            column: 79
          }
        }],
        line: 9
      },
      "1": {
        loc: {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 49,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 16,
            column: 8
          }
        }, {
          start: {
            line: 17,
            column: 4
          },
          end: {
            line: 23,
            column: 8
          }
        }, {
          start: {
            line: 24,
            column: 4
          },
          end: {
            line: 30,
            column: 8
          }
        }, {
          start: {
            line: 31,
            column: 4
          },
          end: {
            line: 41,
            column: 8
          }
        }, {
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 46,
            column: 8
          }
        }, {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 48,
            column: 19
          }
        }],
        line: 11
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0],
      "1": [0, 0, 0, 0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f744f43add4d74eb9cb30c20a1b2eae744c4548a"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1qifkte0gu = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1qifkte0gu();
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var catalogReducerInitialState = (cov_1qifkte0gu().s[0]++, {
  LOADING: false,
  ERROR: false,
  sections: []
});
cov_1qifkte0gu().s[1]++;
var catalog = function catalog() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_1qifkte0gu().b[0][0]++, JSON.parse((0, _stringify.default)(catalogReducerInitialState)));
  var action = arguments.length > 1 ? arguments[1] : undefined;
  cov_1qifkte0gu().f[0]++;
  var newCatalog;
  cov_1qifkte0gu().s[2]++;
  switch (action.type) {
    case 'CATALOG_BEFORE_LOAD':
      cov_1qifkte0gu().b[1][0]++;
      cov_1qifkte0gu().s[3]++;
      return {
        LOADING: true,
        ERROR: false
      };
    case 'CATALOG_LOAD_SUCCESS':
      cov_1qifkte0gu().b[1][1]++;
      cov_1qifkte0gu().s[4]++;
      newCatalog = _model.default.get(action.data, action.config);
      cov_1qifkte0gu().s[5]++;
      return _objectSpread(_objectSpread({}, newCatalog), {}, {
        LOADING: false,
        ERROR: false
      });
    case 'CATALOG_CALENDAR_LOAD_SUCCESS':
      cov_1qifkte0gu().b[1][2]++;
      cov_1qifkte0gu().s[6]++;
      newCatalog = _model.default.getCalendar(action.data, action.config);
      cov_1qifkte0gu().s[7]++;
      return _objectSpread(_objectSpread({}, newCatalog), {}, {
        LOADING: false,
        ERROR: false
      });
    case 'GLOBAL_CHANGE_LANGUAGE':
      cov_1qifkte0gu().b[1][3]++;
      cov_1qifkte0gu().s[8]++;
      newCatalog = _model.default.changeLanguage(action.language, action.defaultLanguage, state.sections);
      cov_1qifkte0gu().s[9]++;
      return _objectSpread(_objectSpread({}, newCatalog), {}, {
        LOADING: false,
        ERROR: false
      });
    case 'CATALOG_LOAD_ERROR':
      cov_1qifkte0gu().b[1][4]++;
      cov_1qifkte0gu().s[10]++;
      return {
        LOADING: false,
        ERROR: true
      };
    default:
      cov_1qifkte0gu().b[1][5]++;
      cov_1qifkte0gu().s[11]++;
      return state;
  }
};
var _default = exports.default = catalog;